import { forwardRef, type Ref, type SVGProps } from "react";
const IconPriceSqftOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 21H11V3a1.003 1.003 0 0 0-1-1H3a1.003 1.003 0 0 0-1 1v26a1.003 1.003 0 0 0 1 1h26a1.003 1.003 0 0 0 1-1v-7a1.003 1.003 0 0 0-1-1m-1 7H4V4h5v2H8a1 1 0 0 0 0 2h1v3H8a1 1 0 0 0 0 2h1v3H8a1 1 0 0 0 0 2h1v5h5v1a1 1 0 0 0 2 0v-1h3v1a1 1 0 0 0 2 0v-1h3v1a1 1 0 0 0 2 0v-1h2z"
    />
    <path
      fill="currentColor"
      d="M20.038 14.587a2.88 2.88 0 0 1-1.947-.831 1.35 1.35 0 0 0-.926-.419.802.802 0 0 0-.865.825 1.58 1.58 0 0 0 .595 1.141 4.03 4.03 0 0 0 2.19.883v.885a.929.929 0 0 0 1.858 0v-.913a2.95 2.95 0 0 0 2.757-2.875c0-1.385-.838-2.23-2.54-2.562l-1.278-.263c-.858-.17-1.25-.494-1.25-1 0-.568.506-1.02 1.303-1.02a2.3 2.3 0 0 1 1.737.763 1.4 1.4 0 0 0 .98.419.75.75 0 0 0 .777-.757 1.62 1.62 0 0 0-.58-1.136 3.7 3.7 0 0 0-1.907-.856v-.943a.929.929 0 0 0-1.857 0v.927a2.834 2.834 0 0 0-2.67 2.772c0 1.378.824 2.257 2.46 2.595l1.27.277c.974.21 1.359.507 1.359 1.014 0 .649-.514 1.074-1.466 1.074"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPriceSqftOutlineSVG);
ForwardRef.displayName = "IconPriceSqftOutline";
export { ForwardRef as IconPriceSqftOutline };
